import { useEffect, useState } from "react";
import "./MindMappingReportASecondSection.css";

const MindMappingReportASecondSection = ({ res,toggle }) => {
  const [courseData, setCourseData] = useState({
    name: "",
    level: "",
    degrees: [],
    niches: ""
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    if (!res?.course) return;

    const currentCourse = res.course;
    
    // Accessibility Mapping
    const accessibilityData = [
      {
        level: "⭐⭐⭐\n⭐⭐ \n Very High",
        courses: ["B.Tech", "B.E"],
        niches: "SaaS, DeepTech, AI/ML, FinTech, Robotics"
      },
      {
        level: "⭐⭐⭐⭐ High",
        courses: ["BCA", "B.Sc", "B.Com", "BBA", "B.Des"],
        niches: "E-commerce, EdTech, D2C Brands, Design Agencies"
      },
      {
        level: "⭐⭐⭐ Medium",
        courses: ["B.Arch", "B.Pharm", "B.Nursing", "B.A", "BSW", "BHM"],
        niches: "PropTech, HealthTech, Social Enterprises, Hospitality"
      },
      {
        level: "⭐⭐ Lower",
        courses: ["BFA"],
        niches: "ArtTech, Creative Platforms, NFT Marketplaces"
      }
    ];

    const match = accessibilityData.find((row) =>
      row.courses.some(c => c.toLowerCase() === currentCourse.toLowerCase())
    );

    if (match) {
      setCourseData({
        name: currentCourse,
        level: match.level,
        degrees: match.courses,
        niches: match.niches
      });
    }
  }, [res]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="mind-mapping-report-a-second-container">
      <div className={toggle?"table-adjust":"mind-mapping-report-a-second-final-table"}> 
        {/* Decorative Corners */}
        <span className="mind-mapping-report-a-second-corner mind-mapping-report-a-second-corner-top-left"></span>
        <span className="mind-mapping-report-a-second-corner mind-mapping-report-a-second-corner-top-right"></span>
        <span className="mind-mapping-report-a-second-corner mind-mapping-report-a-second-corner-bottom-left"></span>
        <span className="mind-mapping-report-a-second-corner mind-mapping-report-a-second-corner-bottom-right"></span>

       <div className="mind-mapping-report-a-second-module-title">
  <span className="module-prefix">Module 2:</span> Course Accessibility
</div>

        {/* 2A: Accessibility Level */}
        <div className="mind-mapping-report-a-second-table-scroll-wrapper">
          <table className="mind-mapping-report-a-second-inner-table">
            <thead>
              <tr>
                <th className="mind-mapping-report-a-second-col-sno">S.NO</th>
                <th>Accessibility Level</th>
                <th>Relevant Degrees</th>
                <th>Current Degree</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="mind-mapping-report-a-second-col-sno">2 A</td>
                <td className="mind-mapping-report-a-second-highlight">
                  {isMobile ? (
                    courseData.level.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        {index < courseData.level.split('\n').length - 1 && <br />}
                      </span>
                    ))
                  ) : (
                    courseData.level
                  )}
                </td>
                <td>{courseData.degrees.join(", ")}</td>
                <td className="mind-mapping-report-a-second-user-val">{courseData.name}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MindMappingReportASecondSection;